/* "CV could not be read" — the console's side of server/src/services/cvScore.js.
 *
 * Since 6 Oct 2026 the screening never scores a CV whose text it could not
 * obtain; older records scored that way carry cvTextSource 'none'. Either
 * way there is no real score, so every screen shows this label instead of a
 * number. Keep the rule identical to the server's isCvUnread. */
export const CV_UNREAD_LABEL = 'CV could not be read';

export function isCvUnread(r) {
  if (!r) return false;
  if (r.cvUnread === true) return true;
  return r.cvTextSource === 'none';
}
